import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Row, Space, Card, Flex, Breadcrumb, Button } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import ModalMaster from "components/elements/Modal/ModalMaster";
import { MainLayout } from "components/layouts";
import MasterMenu from "./MasterDataMenu";
import { MASTER_DATA_TYPE } from "../schemas/masterDataSchema";
import styles from "../styles/MasterData.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useState } from "react";
import MasterDataFilter from "./MasterDataFilter";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

const MasterData = ({
  selectedMenu = null,
  isLoading = false,
  modalProps = {},
  isModalOpen = false,
  getPage = () => { },
  onChange = () => { },
  onSearch = () => { },
  onCreate = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  handleMenuChange = () => { },
  useFilter,
  setUseFilter
}) => {
  console.log(getPage());
  // const [useFilter, setUseFilter] = useState(false);
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  function getItem(rules, label, key, icons) {
    let list = [...roles]
    if (!list.includes(rules)) {
      return null
    }
    return {
      rules: rules,
      label: label,
      key: key,
      icons: icons
    };
  }
  const MENU = [
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|BANK", t("masterdata.title.bank"), MASTER_DATA_TYPE.BANK, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|CAREER", t("masterdata.title.career"), MASTER_DATA_TYPE.CAREER, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|REASON_OF_LEAVING", t("masterdata.title.reason_for_leaving"), MASTER_DATA_TYPE.REASON_FOR_LEAVING, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|ATTACHMENT_TYPE", t("masterdata.title.attachment_type"), MASTER_DATA_TYPE.ATTACHMENT_TYPE, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|EMPLOYEE_TYPE", t("masterdata.title.employee_type"), MASTER_DATA_TYPE.EMPLOYEE_TYPE, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|COMPANY_REGULATION", t("masterdata.title.company_regulation"), MASTER_DATA_TYPE.COMPANY_REGULATION, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|COURCE_CATEGORY", t("masterdata.title.course_category"), MASTER_DATA_TYPE.COURSE_CATEGORY, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|SKILL_TYPE", t("masterdata.title.skill_type"), MASTER_DATA_TYPE.SKILL_TYPE, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|SKILL_SET", t("masterdata.title.skill_set"), MASTER_DATA_TYPE.SKILL_SET, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_CONFIGURATION|COMMON_MASTER|REASON_OF_SEPARATION", t("masterdata.title.reason_for_separation"), MASTER_DATA_TYPE.REASON_FOR_SEPARATION, <CopyOutlined style={{ color: "gray" }} />),
  ].filter(item => item !== null);

  const hasAccess = MENU.length > 0;

  const menuBreadcrumbMapping = MENU.reduce((acc, item) => {
    acc[item.key] = item.label;
    return acc;
  }, {});

  return (
    <MainLayout>
      <ModalMaster
        isLoading={isLoading}
        isModalOpen={isModalOpen}
        onSubmit={onSubmit}
        onCancel={onCancel}
        {...modalProps}
      />
      <Space className={styles.container} size={24} direction="vertical">
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("masterdata.header"), href: "" },
            { title: t("masterdata.header"), href: "" },
            { title: menuBreadcrumbMapping[selectedMenu] || null }
          ]} />
          <h2>{menuBreadcrumbMapping[selectedMenu] || t("masterdata.header")}</h2>
        </Flex>

        {hasAccess ? (
          <MasterMenu menuList={MENU} onChange={handleMenuChange}>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
              <Row justify="end">
                <Space direction="horizontal" size={24}>
                  <Button
                    type="default"
                    onClick={() => setUseFilter(!useFilter)}
                    style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
                    <Flex align="center" justify="center" gap={8}>
                      <FilterIcon />
                      <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                    </Flex>
                  </Button>
                  {
                    roles.includes(String(MENU.find(o => o.key == selectedMenu)?.rules)?.replace("ACCESS", "CREATE")) && <Button onClick={onCreate}
                      style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                      type="primary">
                      <Flex align="center" justify="center" gap={8}>
                        <CreateIcon />
                        <span>{t('common.create')}</span>
                      </Flex>
                    </Button>
                  }

                </Space>
              </Row>
              {useFilter && (
                <Card style={{
                  borderRadius: "8px",
                  backgroundColor: "white",
                  border: "1px solid #EAECF0",
                  height: "100%",
                }}>
                  <MasterDataFilter
                    dataFlag={"master"}
                    onChange={onChange}
                    onSubmit={onSearch}
                    onCancel={onCancel}
                    selectedMenu={selectedMenu}
                    isLoading={isLoading}
                  />
                </Card>
              )}
              {/* <CardContainer width="100%" height="fit-content"> */}
              {getPage()}
              {/* </CardContainer> */}
            </Space>
          </MasterMenu>
        ) : null}
      </Space>
    </MainLayout>
  );
};

export default MasterData;
